module.exports = __webpack_public_path__ + "static/media/adjuge-pl.0b0140db.png";